// extracted by mini-css-extract-plugin
export default {"button":"r4030"};